export const apiUrl1 = "https://api.bitcoinuniverse.io"
export const apiUrl2 = "https://apiv2.bitcoinuniverse.io"
export const apiUrl4 = "https://apiv4.bitcoinuniverse.io"